import { combineReducers } from "redux";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import memberDetailsSlice from "./MemberDetailsReducer/memberDetailsSlice";
import userDetailsSlice from "./UserDetailsReducer/userDetailsSlice";


const persistConfig = {
    key: "root",
    storage,
    whitelist: [],
};

const rootReducer = combineReducers({
    memberDetails: memberDetailsSlice,
    userDetails: userDetailsSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
